import * as React from 'react';

import Icon from '../Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const ClapIcon: React.FC<Props> = props => {
  const size = props.size || 35;
  const color = props.color || '#999999';
  return <Icon name={'project-clap'} size={size} color={color} />;
};

export default React.memo(ClapIcon);
